import '../styles/application.scss'
import Rails from '@rails/ujs'
import Turbolinks from 'turbolinks'

Rails.start()
Turbolinks.start()


import 'jquery'
import 'bootstrap/dist/js/bootstrap'
import './legacy'

import { mountVueApp } from '../init/vueApp'
import { initSidebarToggle } from '../init/sidebar'

document.addEventListener('turbolinks:load', () => {
  mountVueApp()
  initSidebarToggle()
})
